module.exports = __webpack_public_path__ + "img/about-shirel.e12e92a7.jpeg";